import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CSS } from "@dnd-kit/utilities";
import { NumericFormat } from "react-number-format";
export var docStandardList = [
    {
        key: "sorting",
        render: function(param) {
            var customSort = param.customSort, setNodeRef = param.setNodeRef, attributes = param.attributes, listeners = param.listeners, item = param.item, setProductRow = param.setProductRow, index = param.index, transform = param.transform, transition = param.transition;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        style: customSort ? {
                            paddingLeft: 0
                        } : {},
                        children: customSort ? /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                            style: {
                                paddingLeft: "14px",
                                transform: CSS.Transform.toString(transform),
                                transition: transition
                            },
                            ref: setNodeRef
                        }, attributes, listeners), {
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "btn-drag"
                            })
                        })) : /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-start ",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mr-1",
                                    children: [
                                        index + 1,
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    className: "form-check-input",
                                    type: "checkbox",
                                    name: "",
                                    checked: item.is_checked,
                                    onChange: function(e) {
                                        if (e.target.checked === true) {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            is_checked: true
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        } else {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            is_checked: false
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        }
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docNumber",
        render: function(param) {
            var item = param.item;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: /*#__PURE__*/ _jsx("a", {
                            className: "tc-9",
                            href: item.linkUrl,
                            target: "_blank",
                            children: item.docNumber
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "peakDocNumber",
        render: function(param) {
            var item = param.item;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.peakDocNumber
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docRef",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.docRef
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docReceiveDate",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.docReceiveDate
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docSupplierName",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.docSupplierName
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docProductQty",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID != "" ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 0,
                            fixedDecimalScale: true,
                            value: item.docProductQty
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docExVatPrice",
        render: function(param) {
            var item = param.item, values = param.values;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID != "" ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: item.docExVatPrice
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docVatPrice",
        render: function(param) {
            var item = param.item, values = param.values;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID != "" ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: item.docVatPrice
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docIncVatPrice",
        render: function(param) {
            var item = param.item, values = param.values;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID != "" ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: item.docIncVatPrice
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docReviewDate",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.docReviewDate
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "docRemark",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow;
            var _item_docRemark;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control formv text-start border-0 me-2",
                            value: (_item_docRemark = item.docRemark) !== null && _item_docRemark !== void 0 ? _item_docRemark : "",
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                docRemark: e.target.value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    }
];
